document.addEventListener('DOMContentLoaded', function () {
  const viewMoreButton = document.getElementById(
    'eventastic-calendar-view-more'
  );

  // If the button doesn't exist on the page, do nothing.
  if (!viewMoreButton) {
    return;
  }

  const calendarList = document.getElementById('calendarList');

  viewMoreButton.addEventListener('click', function () {
    // Check if the list is currently expanded
    const isExpanded = calendarList.classList.contains('is-expanded');

    if (isExpanded) {
      // --- ACTION: VIEW LESS ---
      const allCards = calendarList.querySelectorAll('.events-card');

      // Hide cards after the 6th one
      allCards.forEach((card, index) => {
        if (index >= 6) {
          card.classList.add('overflow-card');
        }
      });

      this.textContent = 'View More';
      calendarList.classList.remove('is-expanded');
    } else {
      // --- ACTION: VIEW MORE ---
      const hiddenCards = calendarList.querySelectorAll('.overflow-card');

      // Show all hidden cards
      hiddenCards.forEach((card) => {
        card.classList.remove('overflow-card');
      });

      this.textContent = 'View Less';
      calendarList.classList.add('is-expanded');
    }
  });
});